import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { getFullTimetext } from '@reserve/disp-helper';

@Component({

})
export default class EventDetailHover  extends Vue {
    @Prop({ type: Object }) item!: reserve.CalendarItem;

    colorClass: any = {};    

    created() {
        this.colorClass[this.item.color] = true;
    }

    fulltimeText(): string {
        return getFullTimetext(this.item);
    }
}